var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { PageEvent, PageEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isMobile } from '@philips-internal/oswald-ui-utils';
import { getNumberOfPages } from './paginator-utils.js';
class PaginatorAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onNextPage = new PageEventListener();
        /** @event */
        this.onPrevPage = new PageEventListener();
    }
    getData() {
        return this.state.data;
    }
    setData(data) {
        this.setState({ data });
    }
    isLazy() {
        return this.state.lazy;
    }
    setLazy(lazy) {
        this.setState({ lazy });
    }
    getLimit() {
        return this.state.limit;
    }
    setLimit(limit) {
        this.setState({ limit });
    }
    getLoadMoreExpression() {
        return this.state.loadMoreExpression;
    }
    setLoadMoreExpression(loadMoreExpression) {
        this.setState({ loadMoreExpression });
    }
    getNumberOfPages() {
        const { limit, totalCount } = this.state;
        return getNumberOfPages(totalCount, limit);
    }
    getPage() {
        return this.state.page;
    }
    setPage(page) {
        const { limit, page: prevPage } = this.state;
        const accumulate = isMobile();
        if (page === prevPage) {
            return;
        }
        const event = new PageEvent({
            accumulate,
            limit,
            mergeParams: false,
            page,
        });
        const method = page > prevPage ? this.onNextPage : this.onPrevPage;
        method.fire(event);
    }
    getTotalCount() {
        return this.state.totalCount;
    }
    getStartPage() {
        return this.state.startPage;
    }
    setStartPage(startPage) {
        this.setState({ startPage });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], PaginatorAPI.prototype, "onNextPage", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], PaginatorAPI.prototype, "onPrevPage", void 0);
export default PaginatorAPI;
//# sourceMappingURL=paginator-api.js.map